/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins';

// Components
import App from './App.vue';

// Composables
import { createApp } from 'vue';

// Styles
import 'unfonts.css';

// Fabric patches (side effect only)
import '@/helpers/fabricTextDecorationPatch';
import '@/helpers/fabricImageSmoothingPatch';

import { loadFontAccess } from '@/services/font/fontAccess';

/**
 * Fabric: cap retina backing-store at 2x. On 3x phones the default
 * triples both axes (9x pixel work) for negligible visual gain.
 */
import { config as fabricConfig } from 'fabric';

fabricConfig.devicePixelRatio = Math.min(window.devicePixelRatio || 1, 2);

const app = createApp(App);

registerPlugins(app);

/**
 * Font visibility rules. Started here rather than awaited, so app startup is
 * never blocked on the CDN - the font picker reads the rules reactively once
 * they arrive, and shows every font if they never do.
 */
loadFontAccess();

app.mount('#app');
